import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { RunnerForm } from './pages/RunnerForm';
import { RunnerDetail } from './pages/RunnerDetail';
import { Settings } from './pages/Settings';
import { UserManagement } from './pages/UserManagement';
import { Documentation } from './pages/Documentation';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/docs" element={<Documentation />} />
          <Route path="/docs/:docId" element={<Documentation />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/runner/new"
            element={
              <ProtectedRoute>
                <RunnerForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/runner/:runnerId/detail"
            element={
              <ProtectedRoute>
                <RunnerDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/runner/:runnerId"
            element={
              <ProtectedRoute>
                <RunnerForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requireAdmin>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
